<template>
  <app-view-layout
    header="Historia zmian projektu"
    :subheader="projectChanges.projectName"
  >
    <template #toolbarMenu>
      <ProjectChangesToolbarMenu @search="fetchProjectChanges(projectId)" />
    </template>

    <template #content>
      <ProjectChangesSort @search="fetchProjectChanges(projectId)" />
      <v-card
        class="py-6 px-8 mt-5"
        flat
        tile
      >
        <v-card-title class="pa-0">
          Lista zmian
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="projectChanges.collection"
          hide-default-footer
          :loading="isLoading"
          :items-per-page="999"
          class="custom-table mt-6"
        >
          <template #[`item.user`]="{ item }">
            <AppUser :user="item.user" />
          </template>

          <template #[`item.text`]="{ item }">
            <span v-html="item.text" />
          </template>

          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | dateWithTime }}
          </template>

          <template #no-data>
            <AppEmptyList
              class="py-16"
              header="Brak zmian w projekcie."
              text="Brak dostępnych zmian. <br>
                Zmień w filtrach sposób wyszukiwania."
            />
          </template>
        </v-data-table>
      </v-card>
    </template>
  </app-view-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import headers from '@/helpers/tableHeaders';
import ProjectChangesToolbarMenu from '@/components/Projects/Changes/ProjectChangesToolbarMenu.vue';
import ProjectChangesSort from '@/components/Projects/Changes/ProjectChangesSort.vue';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import AppUser from '@/components/UI/AppUser.vue';

export default {
  components: {
    ProjectChangesToolbarMenu,
    ProjectChangesSort,
    AppEmptyList,
    AppViewLayout,
    AppUser,
  },

  data() {
    return {
      headers: headers.projectChanges,
    };
  },

  computed: {
    ...mapState([
      'isLoading',
    ]),
    ...mapState('project', [
      'projectChanges',
    ]),
    projectId() {
      return this.$route.params.id;
    },
  },

  created() {
    this.fetchProjectChanges(this.projectId);
  },

  beforeDestroy() {
    this.clearFilters();
    this.setSorting();
    this.resetProjectChanges();
  },

  methods: {
    ...mapActions('project', [
      'fetchProjectChanges',
      'resetProjectChanges',
    ]),
    ...mapActions('filters', [
      'clearFilters',
      'setSorting',
    ]),
  },

};
</script>

<style lang="scss" scoped>
.custom-table::v-deep td {
  white-space: pre-line;
  padding:12px 8px;
}
</style>
